// extracted by mini-css-extract-plugin
module.exports = {"station-link":"StationLink_station-link__T1EY7","next":"StationLink_next__3B7zO"};